import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d4f2c06a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-wrap" }
const _hoisted_2 = { class: "filter-row" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = {
  style: {"display":"flex"},
  class: "cm-ui-ml10"
}
const _hoisted_5 = { class: "selection-bar" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  style: {"color":"var(--cm-color-text-secondary)","cursor":"not-allowed"}
}
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "terminal-select-wrap terminal-select-dialog",
    title: _ctx.drawerTitle,
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: "70%",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        class: "content-adapt",
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        onTabClick: _ctx.handleTabClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            lazy: "",
            label: _ctx.t('serviceManage.tabConfiguredServices'),
            name: "authorizedView"
          }, null, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            lazy: "",
            label: _ctx.t('serviceManage.tabUnconfiguredServices'),
            name: "unauthorizedView"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_input, {
              style: {"min-width":"280px"},
              size: "small",
              modelValue: _ctx.searchParams.searchKey,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParams.searchKey) = $event)),
              placeholder: _ctx.t('listColumns.serviceName'),
              onChange: _ctx.handleSearch,
              "suffix-icon": "el-icon-search"
            }, null, 8, ["modelValue", "placeholder", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              size: "small",
              disabled: !_ctx.selectionData.length && !_ctx.isSelectAll,
              type: "primary",
              onClick: _ctx.handleBatchOperate
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isAuthorizedView ? _ctx.t('terminalAuth.batchCancel') : _ctx.t('terminalAuth.batchAdd')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
          (0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                disabled: !_ctx.pagination.total || _ctx.isSelectAll,
                onClick: _ctx.handleSelectAll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('terminalAuth.selectAllInGroup')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "text",
            disabled: !_ctx.selectedCount,
            onClick: _ctx.handleCancelSelect
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('terminalAuth.cancelSelect')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "text",
            disabled: !_ctx.selectedCount,
            onClick: _ctx.toggleShowSelected
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isShowSelection ? _ctx.t('subscribeDetails.renewal.closeSelectedWithCount', { n: _ctx.selectedCount }) : _ctx.t('subscribeDetails.renewal.viewSelectedWithCount', { n: _ctx.selectedCount })), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "empty-text": _ctx.$t('common.noData'),
          ref: "tableNode",
          data: _ctx.tableData,
          width: "100%",
          height: "100%",
          "row-key": "permission_name",
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              "reserve-selection": "",
              width: "50",
              selectable: (row) => !_ctx.isSelectAll && !row.is_free
            }, null, 8, ["selectable"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('listColumns.serviceName'),
              "min-width": "200"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.serviceDisplayName(scope.row)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('serviceManage.colServiceType'),
              "min-width": "200"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.serviceClassName(scope.row)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('serviceManage.colRemainingDuration'),
              prop: "expire_day",
              "min-width": "200"
            }, {
              default: _withCtx((scope) => [
                (scope.row.is_free)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.t('serviceAuth.unlimited')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.expire_day) + _toDisplayString(_ctx.t('serviceAuth.unitDay')), 1))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('subscribeDetails.renewal.colExpireTime'),
              prop: "expire_date",
              "min-width": "200"
            }, {
              default: _withCtx((scope) => [
                (scope.row.is_free)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.t('serviceManage.perpetualExpireDateDisplay')), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formatTimeStamp(scope.row.expire_date, 'YYYY-MM-DD')), 1))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "group_name",
              label: _ctx.t('listColumns.operation'),
              "min-width": "70",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (scope.row.is_free)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.isAuthorizedView ? _ctx.t('terminalAuth.cancelConfig') : _ctx.t('terminalAuth.addConfig')), 1))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "cm-link-light",
                      onClick: ($event: any) => (_ctx.handleItemAuth(scope.row))
                    }, _toDisplayString(_ctx.isAuthorizedView ? _ctx.t('terminalAuth.cancelConfig') : _ctx.t('terminalAuth.addConfig')), 9, _hoisted_11))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["empty-text", "data", "onSelectionChange"])), [
          [_directive_loading, _ctx.isLoading]
        ]),
        (0)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              background: "",
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange,
              "current-page": _ctx.pagination.currentPage,
              "page-sizes": [10, 20, 30, 50, 100],
              "page-size": _ctx.pagination.pageSize,
              total: _ctx.pagination.total,
              layout: "total, sizes, prev, pager, next, jumper",
              style: {"text-align":"right","padding-top":"20px"}
            }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]))
}